import axios from 'axios';
import { COSTCENTER_ROSTER_STATE_SETTINGS } from 'RestAPIs/endpoints';

export const getRosterStateSettings = ({ costCenterId }) => {
  const url = COSTCENTER_ROSTER_STATE_SETTINGS.replace(
    ':costCenterId',
    costCenterId
  );
  return axios.get(url);
};

export const saveRosterStateSettings = ({
  costCenterId,
  planningCyclePayload
}) => {
  const url = COSTCENTER_ROSTER_STATE_SETTINGS.replace(
    ':costCenterId',
    costCenterId
  );
  return axios.put(url, planningCyclePayload);
};
